import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { BootContext } from '../store/slices/bootSlice';

export function useBootContext(): BootContext | null {
  return useSelector((state: RootState) => state.boot.context);
}
